/* eslint-disable no-unused-vars */
import Jsbarcode from 'jsbarcode'
import axios from '../axios'
import pouchdb from '../pouchdb'
import config from '../configurations'

const pdf = {
  namespaced: true,
  state: {
    council: config.council,
    data: null,
    database: null,
    digitalLicense: null,
    error: false,
    loading: false
  },
  mutations: {
    setDigitalLicense: function (state, payload) {
      state.digitalLicense = payload.digitalLicense
    },
    setData (state, payload) {
      state.data = payload.data
    },
    setDatabase (state, payload) {
      state.database = payload.database
    },
    setError (state, payload) {
      state.error = payload.error
    },
    setLoading (state, payload) {
      state.loading = payload.loading
    }
  },
  actions: {
    async fetchData (context, payload) {
      try {
        const decoded = atob(payload.id.trim())
        const response = await pouchdb.digital_license.get(decoded)
        context.commit('setData', { data: response })
      } catch (error) {
        context.commit('setError', { error: error })
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    async generateLicensePdf (context, payload) {
      const data = Object.assign({}, context.state.data)

      const type = data.license.m_kod_type === 'niaga' ? 'trading' : 'license'
      const url = `${payload.origin}/#/${type}/digital-license/${btoa(data._id.trim())}`

      let canvas = document.createElement('canvas')
      Jsbarcode(canvas, data.license.no_lesen, { displayValue: false, width: 1, height: 15, margin: 0 })
      const barcode = canvas.toDataURL()

      const logoResponse = await axios.get(`${config.WORKER}/getAttachments/metadata/logo/${config.council}.png`, { responseType: 'arraybuffer' })
      const base64logo = 'data:image/png;base64,' + Buffer.from(logoResponse.data, 'binary').toString('base64') || '-'

      let rawPicture = null
      let picture = ''

      if (data.license.m_kod_type !== 'niaga') {
        try {
          rawPicture = await axios.get(`${config.WORKER}/getAttachments/metadata/license_pictures/${data.license.no_lesen}.jpg`, { responseType: 'arraybuffer' })
          picture = rawPicture ? 'data:image/jpeg;base64,' + Buffer.from(rawPicture.data, 'binary').toString('base64') : '-'
        } catch (error) {}
      }

      let licenseType = ''
      let licenseParams = Object.assign({}, data, {
        barcode,
        logo: base64logo,
        picture,
        url
      })

      switch (data.license.m_kod_type) {
        case 'operasi':
          switch (data.license.lesen_print) {
            case '1':
              licenseType = 'operasi'
              break
            case '2':
              licenseType = 'restoran'
              licenseParams = Object.assign({}, licenseParams, {
                licenseCategory: 'FOOD AND EATING PREMISES'
              })
              break
            case '3':
              licenseType = 'salon'
              licenseParams = Object.assign({}, licenseParams, {
                licenseCategory: 'HAIRDRESSERS'
              })
              break
            case '4':
              licenseType = 'minyak'
              break
            case '10':
              licenseType = 'rumah-urut'
              break
            default:
              licenseType = 'amusement'
              break
          }
          break
        case 'pasar':
          licenseType = 'pasar'
          licenseParams = Object.assign({}, licenseParams, {
            licenseCategory: 'PASAR',
            workingHour: 'SEPANJANG HARI'
          })
          break
        case 'penjaja':
          if (data.license.kat_j_niaga === 'PENJAJA BERGERAK') {
            licenseType = 'penjaja-bergerak'
            licenseParams = Object.assign({}, licenseParams, {
              licenseCategory: 'MARKET'
            })
          } else {
            licenseType = 'penjaja'
            licenseParams = Object.assign({}, licenseParams, {
              licenseCategory: 'MARKET'
            })
          }
          break
        case 'kakilima':
          licenseType = 'kakilima'
          break
        case 'iklan':
          licenseType = null
          break
        case 'niaga':
          licenseType = 'trading'
          break
        default:
          licenseType = null
          break
      }
      return { licenseParams, licenseType }
    }
  }
}

export default pdf
